import React, { useState } from "react";
import { motion } from "framer-motion";

const Contact = () => {
  const [formData, setFormData] = useState({
    nom: "",
    email: "",
    sujet: "",
    message: "",
  });

  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    // Ici nous simulerons l'envoi du formulaire
    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 3000);
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const locations = [
    {
      ville: "Meknes",
      adresse: "123 Avenue Mohamed V",
      telephone: "+212 XX XX XX XX",
      email: "meknes@clinique-numerique.com",
    },
    {
      ville: "Pointe-Noire",
      adresse: "456 Boulevard de la République",
      telephone: "+242 XX XX XX XX",
      email: "pointe-noire@clinique-numerique.com",
    },
    {
      ville: "Brazzaville",
      adresse: "789 Boulevard de la République",
      telephone: "+242 XX XX XX XX",
      email: "brazzaville@clinique-numerique.com",
    },
  ];

  return (
    <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-center mb-12"
      >
        <h1 className="text-4xl font-bold text-gray-900 mb-4">
          Contactez-nous
        </h1>
        <p className="text-xl text-gray-600">
          Nous sommes là pour répondre à vos questions
        </p>
      </motion.div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
        {/* Formulaire de contact */}
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          className="bg-white rounded-lg shadow-lg p-8"
        >
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label htmlFor="nom" className="block text-gray-700 font-medium mb-2">
                Nom complet
              </label>
              <input
                type="text"
                id="nom"
                name="nom"
                value={formData.nom}
                onChange={handleChange}
                required
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
              />
            </div>

            <div>
              <label htmlFor="email" className="block text-gray-700 font-medium mb-2">
                Email
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
              />
            </div>

            <div>
              <label htmlFor="sujet" className="block text-gray-700 font-medium mb-2">
                Sujet
              </label>
              <select
                id="sujet"
                name="sujet"
                value={formData.sujet}
                onChange={handleChange}
                required
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
              >
                <option value="">Sélectionnez un sujet</option>
                <option value="consultation">Consultation</option>
                <option value="partenariat">Partenariat</option>
                <option value="support">Support technique</option>
                <option value="autre">Autre</option>
              </select>
            </div>

            <div>
              <label htmlFor="message" className="block text-gray-700 font-medium mb-2">
                Message
              </label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
                rows="4"
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
              ></textarea>
            </div>

            <motion.button
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              type="submit"
              className="w-full bg-blue-600 text-white py-3 px-6 rounded-md hover:bg-blue-700 transition-colors"
            >
              Envoyer le message
            </motion.button>

            {submitted && (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                className="mt-4 p-4 bg-green-100 text-green-700 rounded-md"
              >
                Message envoyé avec succès ! Nous vous répondrons dans les plus brefs délais.
              </motion.div>
            )}
          </form>
        </motion.div>

        {/* Informations de contact */}
        <motion.div
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          className="space-y-8"
        >
          {locations.map((location, index) => (
            <motion.div
              key={location.ville}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              className="bg-white rounded-lg shadow-lg p-6"
            >
              <h3 className="text-xl font-semibold text-gray-900 mb-4">
                {location.ville}
              </h3>
              <div className="space-y-2 text-gray-600">
                <p className="flex items-center">
                  <span className="mr-2">📍</span>
                  {location.adresse}
                </p>
                <p className="flex items-center">
                  <span className="mr-2">📞</span>
                  {location.telephone}
                </p>
                <p className="flex items-center">
                  <span className="mr-2">📧</span>
                  {location.email}
                </p>
              </div>
            </motion.div>
          ))}

          <div className="bg-blue-50 rounded-lg p-6 mt-8">
            <h3 className="text-xl font-semibold text-blue-900 mb-4">
              Horaires d'ouverture
            </h3>
            <div className="space-y-2 text-gray-600">
              <p>Lundi - Vendredi : 8h00 - 18h00</p>
              <p>Samedi : 9h00 - 13h00</p>
              <p>Dimanche : Fermé</p>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Contact;